import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=263070be&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=263070be&prod&lang=less&scoped=true"
import style1 from "./ranking.vue?vue&type=style&index=1&id=263070be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263070be",
  null
  
)

export default component.exports